import { AnyAction } from "redux";
import actions from "../../util/actions";
import { VerseReducerState } from "../../interfaces";

const initialState: VerseReducerState = {
  initial: false,
  loading: false,
  error: null,
  response: null,
  fullVerse: []
};

const reducer = (state = initialState, action: AnyAction): VerseReducerState => {
  switch (action.type) {
    case actions.VERSE_HTTP_LOADING:
      return { ...state, response: null, loading: true, error: null };
    case actions.VERSE_HTTP_ERROR:
      if (action.payload.clear) {
        return { ...state, response: null, loading: false, error: null };
      }
      return { ...state, response: null, loading: false, error: { ...action.payload } };
    case actions.VERSE_HTTP_COMPLETE:
      return { ...state, initial: true, response: action.payload.response, loading: false, error: null };
    case actions.SET_FULL_VERSE_DETAILS:
      return { ...state, fullVerse: action.payload };
    default:
      return state;
  }
};

export default reducer;
